import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=3cfae3e0&"
import script from "./Tags.js?vue&type=script&lang=js&"
export * from "./Tags.js?vue&type=script&lang=js&"
import style0 from "./Tags.vue?vue&type=style&index=0&id=3cfae3e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports